import axios from "axios";
import { IDashboard, getWeatherDataTypes, PowerFlowData } from "./interfaces";

const apiURL = process.env.REACT_APP_API_URL;

//#region JobsCreatedtoday
export const getJobsCreatedToday = async (): Promise<number> => {
  const token = localStorage.getItem("authToken");

  if (!token) {
    throw new Error("Authorization token not found");
  }

  const response = await axios.get<number>(
    `https://${apiURL}/Dashboard/JobsCreatedToday`,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    }
  );

  const data = response.data;

  return data;
};
//#endregion

//#region JobsCompletedtoday
export const getJobsCompletedToday = async (): Promise<number> => {
  const token = localStorage.getItem("authToken");

  if (!token) {
    throw new Error("Authorization token not found");
  }

  const response = await axios.get<number>(
    `https://${apiURL}/Dashboard/JobsCompletedToday`,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    }
  );

  const data = response.data;

  return data;
};
//#endregion

//#region JobsCreatedThisMonth
export const getJobsCreatedThisMonth = async (): Promise<number> => {
  const token = localStorage.getItem("authToken");

  if (!token) {
    throw new Error("Authorization token not found");
  }

  const response = await axios.get<number>(
    `https://${apiURL}/Dashboard/JobsCreatedThisMonth`,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    }
  );

  const data = response.data;

  return data;
};
//#endregion

//#region JobsCreatedThisMonth
export const getJobsCreatedThisMonthLastYear = async (): Promise<number> => {
  const token = localStorage.getItem("authToken");

  if (!token) {
    throw new Error("Authorization token not found");
  }

  const response = await axios.get<number>(
    `https://${apiURL}/Dashboard/JobsCreatedThisMonthLastYear`,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    }
  );

  const data = response.data;

  return data;
};
//#endregion

//#region QuotesCreatedToday
export const getQuotesCreatedToday = async (): Promise<number> => {
  const token = localStorage.getItem("authToken");

  if (!token) {
    throw new Error("Authorization token not found");
  }

  const response = await axios.get<number>(
    `https://${apiURL}/Dashboard/QuotesCreatedToday`,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    }
  );

  const data = response.data;

  return data;
};
//#endregion

//#region QuotesWonToday
export const getQuotesWonToday = async (): Promise<number> => {
  const token = localStorage.getItem("authToken");

  if (!token) {
    throw new Error("Authorization token not found");
  }

  const response = await axios.get<number>(
    `https://${apiURL}/Dashboard/QuotesWonToday`,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    }
  );

  const data = response.data;

  return data;
};
//#endregion

//#region QuotesCreatedThisMonth
export const getQuotesCreatedThisMonth = async (): Promise<number> => {
  const token = localStorage.getItem("authToken");

  if (!token) {
    throw new Error("Authorization token not found");
  }

  const response = await axios.get<number>(
    `https://${apiURL}/Dashboard/QuotesCreatedThisMonth`,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    }
  );

  const data = response.data;

  return data;
};
//#endregion

//#region QuotesWonThisYearPercent
export const getQuotesWonThisYearPercent = async (): Promise<number> => {
  const token = localStorage.getItem("authToken");

  if (!token) {
    throw new Error("Authorization token not found");
  }

  const response = await axios.get<number>(
    `https://${apiURL}/Dashboard/QuotesWonThisYearPercent`,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    }
  );

  const data = response.data;

  return data;
};
//#endregion

//#region QuotesCreatedThisMonthLastYear
export const getQuotesCreatedThisMonthLastYear = async (): Promise<number> => {
  const token = localStorage.getItem("authToken");

  if (!token) {
    throw new Error("Authorization token not found");
  }

  const response = await axios.get<number>(
    `https://${apiURL}/Dashboard/QuotesCreatedThisMonthLastYear`,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    }
  );

  const data = response.data;

  return data;
};
//#endregion

//#region QuotesWonPercent
export const getQuotesWonPercent = async (): Promise<number> => {
  const token = localStorage.getItem("authToken");

  if (!token) {
    throw new Error("Authorization token not found");
  }

  const response = await axios.get<number>(
    `https://${apiURL}/Dashboard/QuotesWonPercent`,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    }
  );

  const data = response.data;

  return data;
};
//#endregion

//#region QuotesWonPercentLastYear
export const getQuotesWonPercentLastYear = async (): Promise<number> => {
  const token = localStorage.getItem("authToken");

  if (!token) {
    throw new Error("Authorization token not found");
  }

  const response = await axios.get<number>(
    `https://${apiURL}/Dashboard/QuotesWonPercentLastYear`,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    }
  );

  const data = response.data;

  return data;
};
//#endregion

//#region QuotesRecent
export const getQuotesRecent = async (): Promise<number> => {
  const token = localStorage.getItem("authToken");

  if (!token) {
    throw new Error("Authorization token not found");
  }

  const response = await axios.get<number>(
    `https://${apiURL}/Dashboard/QuotesRecent`,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    }
  );

  const data = response.data;

  return data;
};
//#endregion

//#region EnquiriesCreatedToday
export const getEnquiriesCreatedToday = async (): Promise<number> => {
  const token = localStorage.getItem("authToken");

  if (!token) {
    throw new Error("Authorization token not found");
  }

  const response = await axios.get<number>(
    `https://${apiURL}/Dashboard/EnquiriesCreatedToday`,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    }
  );

  const data = response.data;

  return data;
};
//#endregion

//#region EnquiriesCreatedThisMonth
export const getEnquiriesCreatedThisMonth = async (): Promise<number> => {
  const token = localStorage.getItem("authToken");

  if (!token) {
    throw new Error("Authorization token not found");
  }

  const response = await axios.get<number>(
    `https://${apiURL}/Dashboard/EnquiriesCreatedThisMonth`,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    }
  );

  const data = response.data;

  return data;
};
//#endregion

//#region EnquiriesCreatedThisMonthLastYear
export const getEnquiriesCreatedThisMonthLastYear = async (): Promise<number> => {
  const token = localStorage.getItem("authToken");

  if (!token) {
    throw new Error("Authorization token not found");
  }

  const response = await axios.get<number>(
    `https://${apiURL}/Dashboard/EnquiriesCreatedThisMonthLastYear`,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    }
  );

  const data = response.data;

  return data;
};
//#endregion

//#region EnquiriesNotQuoted
export const getEnquiriesNotQuoted = async (): Promise<number> => {
  const token = localStorage.getItem("authToken");

  if (!token) {
    throw new Error("Authorization token not found");
  }

  const response = await axios.get<number>(
    `https://${apiURL}/Dashboard/EnquiriesNotQuoted`,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    }
  );

  const data = response.data;

  return data;
};
//#endregion

//#region InvoicesCreatedThisMonth
export const getInvoicesCreatedThisMonth = async (): Promise<number> => {
  const token = localStorage.getItem("authToken");

  if (!token) {
    throw new Error("Authorization token not found");
  }

  const response = await axios.get<number>(
    `https://${apiURL}/Dashboard/InvoicesCreatedThisMonth`,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    }
  );

  const data = response.data;

  return data;
};
//#endregion

//#region InvoicesCreatedToday
export const getInvoicesCreatedToday = async (): Promise<number> => {
  const token = localStorage.getItem("authToken");

  if (!token) {
    throw new Error("Authorization token not found");
  }

  const response = await axios.get<number>(
    `https://${apiURL}/Dashboard/InvoicesCreatedToday`,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    }
  );

  const data = response.data;

  return data;
};
//#endregion

//#region ChartData
export const getChartData = async () => {
  const token = localStorage.getItem("authToken");

  if (!token) {
    throw new Error("Authorization token not found");
  }

  const response = await axios.get(
    `https://${apiURL}/Dashboard/ChartData`,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    }
  );

  const data = response.data;

  return data;
};
//#endregion

//#region Dashboard Weather data
export const getCurrentWeather = async () => {
  const response = await axios.get<getWeatherDataTypes>(
    'https://api.open-meteo.com/v1/forecast?latitude=50.9416&longitude=-2.6321&current=temperature_2m,is_day,rain,showers,cloud_cover&hourly=temperature_2m&daily=temperature_2m_max,temperature_2m_min',
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );

  const { 
    current, 
    daily: { 
      time,
      temperature_2m_max, 
      temperature_2m_min
    } 
  } = response.data;

  const processedCurrent = {
    ...current,
    temperature: current.temperature_2m,
    isDay: current.is_day,
    cloudCover: current.cloud_cover,
  }

  function getDayName(dateStr: any, locale: any)
  {
      let date = new Date(dateStr);
      return date.toLocaleDateString(locale, { weekday: 'short', day: 'numeric', month: 'short' });
  }

  const processedDaily = temperature_2m_max.map((maxTemp: number, index: number) => ({
    time: getDayName(time[index], "en-GB"),
    maxTemp,
    minTemp: temperature_2m_min[index]
  }));

  const formattedResponse = {
    current: processedCurrent,
    daily: processedDaily
  };

  return formattedResponse;
};
//#endregion

//#region Vehicle Locations
export interface VehicleLocation {
  serviceID: number;
  vehicleRegistration: string;
  vehicleIcon: string;
  geoStreet: string;
  geoTown: string;
  geoCountry: string;
  geoPostCode: string;
  gpsLatitude: number;
  gpsLongitude: number;
  gpsTime: string;
  serviceFlags: number;
  vin: string;
  usdot: string;
  voltage: number;
  status: string;
  statusUpdateDate: string;
  employeeName?: string;
  hexColor?: string;
  workTypeGroup?: string;
}

export const getVehicleLocations = async (): Promise<VehicleLocation[]> => {
  const token = localStorage.getItem("authToken");

  if (!token) {
    throw new Error("Authorization token not found");
  }

  try {
    const response = await axios.get<VehicleLocation[]>(
      `https://${apiURL}/VehicleLocation`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
      }
    );
    return response.data;
  } catch (error: any) {
    console.error('Vehicle Locations API Error:', {
      status: error?.response?.status,
      statusText: error?.response?.statusText,
      url: `https://${apiURL}/VehicleLocations`,
      message: error?.message,
      data: error?.response?.data
    });

    // Fallback to mock data for development if endpoint not available
    if (error?.response?.status === 404 ) {
      console.warn('Using mock vehicle data for development');
      return [
        {
          serviceID: 301987,
          vehicleRegistration: "MALIK HJ22 LPZ ",
          vehicleIcon: "https://tracking.matrixtelematics.com/images/icons/vehicles/48x48/ServiceVanGrey.png",
          geoStreet: "Poyntington",
          geoTown: "Sherborne",
          geoCountry: "GBR",
          geoPostCode: "DT9 4RL",
          gpsLatitude: 50.9777583,
          gpsLongitude: -2.5131516,
          gpsTime: "2025-12-10T07:53:21",
          serviceFlags: 3,
          vin: "",
          usdot: "",
          voltage: 14.86400032043457,
          status: "None",
          statusUpdateDate: "2024-08-23T12:14:26"
        },
        {
          serviceID: 301989,
          vehicleRegistration: "FLORIN HJ22 LPO ",
          vehicleIcon: "https://tracking.matrixtelematics.com/images/icons/vehicles/48x48/ServiceVanGreen.png",
          geoStreet: "Zeals Rise",
          geoTown: "Warminster",
          geoCountry: "GBR",
          geoPostCode: "BA12 6PL",
          gpsLatitude: 51.0838349,
          gpsLongitude: -2.3181816,
          gpsTime: "2025-12-10T11:14:38",
          serviceFlags: 0,
          vin: "",
          usdot: "",
          voltage: 12.421999931335449,
          status: "None",
          statusUpdateDate: "2025-09-22T10:21:24"
        }
      ];
    }

    throw error;
  }
};
//#endregion

//#region PowerFlow
export const getPowerFlowData = async (): Promise<PowerFlowData> => {
  const token = localStorage.getItem("authToken");

  if (!token) {
    throw new Error("Authorization token not found");
  }

  const response = await axios.get<PowerFlowData>(
    `https://${apiURL}/dashboard/powerflow`,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    }
  );

  return response.data;
};
//#endregion
